import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
// import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Box, Button, Card, IconButton, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import PartOrderComment from "./PartOrderComment";
import ViewPDF from "./ViewPDF";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import PendingAbReportSummary from "../../reports/pendingAbReport/pendingAbReportSummary";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress":
    {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: "26px",
      lineHeight: "26px",
      padding: "0px 10px",
      marginTop: "6px",
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const ABAction = (props) => {
  const [open, setOpen] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handlePDFClose = () => {
    setOpenPDF(false);
  };

  const handleComment = () => {
    setOpen(true);
  };

  const handleViewPDF = () => {
    setOpenPDF(true);
  };

  const handleSubmit = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={"PDF"}>
        <IconButton onClick={handleViewPDF}>
          <FuseSvgIcon size={16} color="action">
            heroicons-outline:document-text
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={"Comment"}>
        <IconButton onClick={handleComment}>
          <FuseSvgIcon size={16} color="action">
            heroicons-outline:annotation
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={"Send"}>
        <IconButton>
          <FuseSvgIcon size={16} color="action">
            heroicons-outline:arrow-circle-right
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <PartOrderComment
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        title={'Comment'}
      />
      <ViewPDF open={openPDF} handleClose={handlePDFClose} title={'View AB PDF'} />
    </>
  );
};

const handleDateFormat = (props) => {
  return props.value && moment(props.value).format('DD-MM-YYYY - HH:mm')
}

const PendingABsList = (props) => {
  const theme = useTheme();
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [error, setError] = useState();
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.dashboardOrderCriteria}`;
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const stateRef = useRef();
  const saveGridStateName = 'pendingABsList';
  const [gridApi, setGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [enableEK, setEnableEK] = useState(false);
  const [enableNolte, setEnableNolte] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      resizable: true,
      editable: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: { defaultToNothingSelected: true, buttons: ["clear"] },
          },
        ],
      },
    };
  }, []);
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    [],
  );
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);


  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const onSelectionChanged = (params) => {
    const rows = params.api.getSelectedRows();
    setSelectedRows(rows);



  };
  useEffect(() => {
    if (selectedRows.length === 0) {
      setEnableEK(false);
      setEnableNolte(false);
      return;
    }

    const allAreEk = selectedRows.every(r => r.vendorNum === 60002);
    const noneAreNolte = selectedRows.every(
      r =>
        r.vendorNum === 60001 ||
        r.vendorNum === 60008 ||
        r.vendorNum === 60006 ||
        r.vendorNum === 60009
    );


    if (allAreEk) {
      setEnableEK(true);
      setEnableNolte(false);
    } else if (noneAreNolte) {
      setEnableEK(false);
      setEnableNolte(true);
    } else {
      // Mixed selection
      setEnableEK(false);
      setEnableNolte(false);
    }
  }, [selectedRows])


  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      maxWidth: 60,
      field: "srNo",
      pinned: "left",
      filter: false,
      resizable: true,
      editable: false,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      field: "abNumber",
      headerName: "AB Number",
      enableRowGroup: true,
      minWidth: 50,

    },
    {
      field: "commissionName",
      headerName: "Commission Name",
      enableRowGroup: true,
      minWidth: 250,

    },
    {
      field: "orderCategory",
      headerName: "Category",
      enableRowGroup: true,
      minWidth: 50,


    },
    {
      field: "customerNum",
      headerName: "Customer No",
      enableRowGroup: true,
     minWidth: 50,

    },
    {
      field: "customerName",
      headerName: "Customer",
      enableRowGroup: true,
      minWidth: 50,

    },
    {
      field: "vendorShortKey",
      headerName: "Product",
      enableRowGroup: true,
        minWidth: 50,
      filterParams: { buttons: ['clear'] },

    },
    {
      field: "country",
      headerName: "Country",
      enableRowGroup: true,
       minWidth: 50,

    },
    {
      field: "documentNum",
      headerName: "Document No",
        minWidth: 50,
    },

    {
      field: "orderPlacedDate",
      enableRowGroup: true,
      headerName: "Order Placed",
      cellRenderer: handleDateFormat,
      sort: "desc",
      minWidth: 50,
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      headerName: "Due (Days)",
      minWidth: 30,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      valueGetter: (params) => {
        if (!params.data || !params.data.orderPlacedDate) {
          return null;
        }

        const orderPlacedDate = moment(params.data.orderPlacedDate);
        const currentDate = moment();
        const timeDifference = currentDate.diff(orderPlacedDate, "days");

        return timeDifference;
      },
    },
  ]);

  const handleDefaultGridState = () => {
    gridRef.current.api.setFilterModel(null);
    gridRef.current.columnApi.resetColumnState();

  };

  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);

  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(data.screenState.columnGroupState);
        }
      } catch (err) {
        console.error('Failed to load grid state:', err);
      }
    }

  };
  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(`gridState-${saveGridStateName}`, JSON.stringify(stateRef.current));
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);


  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
    if (!gridApi) return;
    gridApi.refreshCells({ columns: ["srNo"] });
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

  useEffect(() => {
    if(gridApi)
    getPendingABList()
  }, [gridApi]);

  const getPendingABList = async () => {
   gridApi?.showLoadingOverlay();
    try {
      const result = await OAuthService.addData(`${url}?tilesStatus=pendingAb&sort=orderPlacedDate,desc`, {});
      setRowData(result.data);

    } catch (e) {
      console.log("error", e);
      setError(e.message);
      setRowData([]);
    }finally {
    gridApi?.hideOverlay();
  }
  }


  const onRowDoubleClicked = (params) => {
    var filename = params?.data?.id;
    navigate("/order/order-details/" + filename);
  };

  const handleCreateOrder = () => {
    navigate("/create-order/");
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: 'PendingABs.xlsx',
      sheetName: 'Pending ABs'
    }
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handleBack = () => {
    navigate("/order/dashboard");
  };
  const handleToGenerateReport = () => {
    setReportOpen(true);

  }
  const handleReportClose = () => {
    setReportOpen(false);
    setSelectedRows([]);

    if (gridRef.current) {
      gridRef.current.api.deselectAll();
    }
  }
  const orderHeaderAction = () => {
    return (
      <>
        <Tooltip title={"Back"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleBack}
            size="small"
            sx={{ minWidth: 'auto' }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:arrow-narrow-left</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Generate Nolte Reports"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleToGenerateReport}
            size="small"
            sx={{ minWidth: 'auto' }}
            disabled={!enableNolte}
          >
            Nolte Reports
          </Button>
        </Tooltip>
        <Tooltip title={"Generate EK Reports"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleToGenerateReport}
            size="small"
            sx={{ minWidth: 'auto' }}
            disabled={!enableEK}
          >
            EK Reports
          </Button>
        </Tooltip>
        <Tooltip title={"Export Pending AB's Order"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: 'auto' }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Default Grid State"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDefaultGridState}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>material-outline:grid_on</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <FormPageHeader
        componentName="Pending ABs"
        pageName="Pending ABs"
        currentPage={"Pending ABs"}
        error={error}
        // onBtExport={onBtExport}
        orderHeaderAction={orderHeaderAction()}
      >
        {/* <Box className="flex px-16" sx={{ pb: 1 }}>
                <Box sx={{ px: 1 }}>
                  <Select
                    required
                    placeholder={'Customer'}
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Box>
                <Box sx={{ px: 1 }}>
                  <Select
                    required
                    placeholder={'Country'}
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Box>
                <Box sx={{ px: 1 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
                  >
                    Search
                  </Button>
                </Box>
              </Box> */}
      </FormPageHeader>
      <div
        className={clsx(classes.root, "h-full order-grid")}
        style={{ height: "100%", width: "100%" }}
      >
        <div
          style={gridStyle}
          className={`grid ${theme.palette.mode === "dark"
            ? "ag-theme-alpine-dark"
            : "ag-theme-alpine"
            }`}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            defaultColDef={defaultColDef}
            onFilterChanged={onFilterChanged}
            ref={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            hideCheckbox={true}
            editable={false}
            rowHeight={22}
            headerHeight={30}
            rowSelection="multiple"
            onSelectionChanged={onSelectionChanged}
            onFirstDataRendered={onFirstDataRendered}
            onColumnMoved={onColumnStateChanged}
            onColumnPinned={onColumnStateChanged}
            onColumnVisible={onColumnStateChanged}
            onColumnResized={onColumnStateChanged}
            onColumnRowGroupChanged={onColumnGroupChange}
            suppressDragLeaveHidesColumns={true}
            rowGroupPanelShow="always"
            groupDisplayType="multipleColumns"
            cellSelection={true}
            suppressRowClickSelection={true}
            autoGroupColumnDef={{
              headerName: "Group",
              minWidth: 200,
              cellRendererParams: {
                suppressCount: false,
                checkbox: false,
              },
              pinned: "left",
            }}
          />
        </div>
      </div>
      <PendingAbReportSummary
        open={reportOpen}
        currentOrder={selectedRows}
        handleClose={handleReportClose}
      />
    </>
  );
};

export default PendingABsList;
